import { DayOfWeek } from '@weareopenr/types';
import { TDay } from '../../api/getMenu/types';
import { DAYS } from 'src/constants';

export const getDayIndex = (day: TDay): number => {
  return DAYS.indexOf(day) + 1;
};

// day of week 1 = MONDAY ... 7 = SUNDAY
export const getDay = (dayOfWeek: number): TDay => {
  return DAYS[dayOfWeek - 1];
};

// e.g. 'MONDAY' -> 'Mo'
export const getDayLabel = (day: DayOfWeek | TDay, length: number = 2): string =>
  `${day.charAt(0)}${day.charAt(length - 1).toLowerCase()}`;
